export const MOBILE_APP_PROMOTION_BANNER_LIFETIME = 7;
